import { createFileRoute } from "@tanstack/react-router";
import GyroscopeFlow from "@/features/assessments/pages/gyroscope/GyroscopeFlow";

export const Route = createFileRoute("/$locale/$partner/_evaluation/gyroscope")({
	component: GyroscopeFlow,
});
